import { useTranslation } from "react-i18next";
import { BookingTypeEnum } from "@rentablo/api/apiv1";
import { Badge, BadgeVariant } from "@rentablo/components";

export const BookingType = ({
  type,
  size = "medium",
}: {
  type?: BookingTypeEnum;
  // "small" fits a line of caption text, e.g. in the phone bookings list.
  size?: "small" | "medium";
}) => {
  const { t } = useTranslation();
  const map: Record<BookingTypeEnum, BadgeVariant> = {
    buy: "success",
    book_in: "success",
    sell: "info",
    book_out: "info",
    dividend: "secondary",
    split: "secondary",
    reverse_split: "secondary",
    switch: "secondary",
    retained_dividend: "secondary",
    purchase_right: "secondary",
    carve_out: "secondary",
    pre_tax_allowance: "secondary",
    cap_gains_tax: "secondary",
    cap_gains_tax_refund: "secondary",
    fees: "secondary",
  };

  if (!type) {
    return null;
  }

  return (
    <Badge
      variant={map[type]}
      {...(size === "small"
        ? { textVariant: "caption2" as const, py: 0, px: 1.5, flex: "none" }
        : {})}
    >
      {t(`bookingTypes.${type}`)}
    </Badge>
  );
};
